module.exports = __webpack_public_path__ + "img/websiteProject.b90d3429.svg";